import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Button, Row, Col, Spinner, Form } from 'react-bootstrap';
import { InputField, SelectField, TextAreaField } from "../../../lib/formControls";
import { uploadToS3 } from "../../../lib/appFileUpload";
import imageIcon from "../../../common/images/imageIcon.png";

const MAX_FILE_SIZE = 30 * 1024 * 1024; // 50MB
const MIN_FILE_SIZE = 1 * 1024;        // 1KB

const SUPPORTED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/bmp',
  'image/svg+xml'
];

const schema = yup.object().shape({
  firstName: yup.string().required('Incharge First Name is required'),
  staffId: yup.string().required('Staff ID is required'),
  gender: yup.string().required('Select the gender'),
  email: yup.string().email('Enter a valid email').required('Email is required'),
  phone: yup
    .string()
    .required('Phone number is required')
    .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits'),
 profileImageInpt: yup
    .mixed()
    .nullable()
    .test('fileType', 'Only image files are allowed', (value) => {
      if (!value) return true; // not mandatory
      return SUPPORTED_FILE_TYPES.includes(value.type);
    })
    .test('fileSize', 'File size must be between 1KB and 30MB', (value) => {
      if (!value) return true; // not mandatory
      return value.size >= MIN_FILE_SIZE && value.size <= MAX_FILE_SIZE;
    })
});


const InchargeForm = ({ mode = 'add', onSubmit, handleAction, initialData = {}, loading=false }) => {
  const {
  register,
  handleSubmit,
  reset,
  watch,
  setValue,
  clearErrors,
  control,
  formState: { errors, isSubmitting }
} = useForm({
  resolver: yupResolver(schema, { context: { mode } }),
  defaultValues: {
    firstName: '',
    lastName: '',
    staffId: '',
    gender: '',
    email: '',
    phone: '',
    profileImageInpt: '',
    profileImage: ''
  }
});

  const [file, setFile] = useState(null);
  const [fileUploading, setFileUploading] = useState(false);
  const [actiondisable, setActiondisable] = useState(true);
  
  const watchFirstName = watch("firstName");
  const watchLastName = watch("lastName");
  const watchStaffId = watch("staffId");
  const watchGender = watch("gender");
  const watchPhone = watch("phone");
  const watchProfileImage = watch("profileImage");

  useEffect(() => {
    if (watchFirstName || watchLastName || watchStaffId || watchGender || watchPhone || watchProfileImage) {
      setActiondisable(false);
    }
    if (watchFirstName === '' && watchLastName === '' && watchStaffId === '' && watchGender === '' && watchPhone === '' && watchProfileImage === '') {
      setActiondisable(true);
    }
  }, [watchFirstName, watchLastName, watchStaffId, watchGender, watchPhone, watchProfileImage]);

  useEffect(() => {
    /*if (mode === 'edit' && initialData) {*/
    if (initialData) {  
      Object.keys(initialData).forEach((key) => {
        setValue(key, initialData[key]);
      });
    }
  }, [mode, initialData, setValue]);

  const handleSubmitForm = (data) => {
    console.log('Submitting form data:', data);
    onSubmit(data);
  };

const handleFileChange = async (e) => {
      const selectedFile = e.target.files[0];
      if (selectedFile) {
        setFile(selectedFile);
        setValue('profileImageInpt', selectedFile);
        setValue('profileImage', '');
        setFileUploading(true); 
        clearErrors('profileImageInpt');

        try {

          const timestamp = Date.now();
          const fileExtension = selectedFile.name.split(".").pop() || "jpeg";
          const filename = `profile-${timestamp}.${fileExtension}`;

          const { key, url } = await uploadToS3({
            file: selectedFile,
            key: `gemicates/${filename}`,
            contentType: selectedFile.type,
          });

          console.log('url=', url);
          // Set the file URL to the form
          setValue('profileImage', url);
        } catch (err) {
          console.error("Error uploading file to S3:", err);
          clearErrors('profileImageInpt');
        } finally {
          setFileUploading(false);  
        }
      } else {
        setFile(null);
        setValue('profileImageInpt', '');
        setValue('profileImage', '');
      }
};

  return (
    <form className='d-flex flex-column petrolbunk-commonfromcls incharge-from-main' onSubmit={handleSubmit(handleSubmitForm)}>

      <div className='form-header-main'>
          <div className='form-header-row'>
              <div className='form-header-text'><h6><span onClick={() => handleAction('go-to-bunk')} className='back-arrow-main'><i className='bx bx-arrow-back'></i></span> Incharge Details (2/3)</h6> </div>
              <div className='form-header-icon'> <button type="button" onClick={() => handleAction('close-form')} className="btn-close position-absolute end-0 top-0 m-3"></button> </div>
          </div>
      </div>

      <Row>
        <Col md={12}>
          <InputField
            label="Incharge First Name"
            name="firstName"
            type="text"
            placeholder="Incharge First Name"
            controlclass="form-custom-group"
            required={true}
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <InputField
            label="Incharge Last Name"
            name="lastName"
            type="text"
            placeholder="Incharge Last Name"
            controlclass="form-custom-group"
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <InputField
            label="Staff ID"
            name="staffId"
            type="text"
            placeholder="Staff ID"
            controlclass="form-custom-group"
            required={true}
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
           <SelectField
            label="Gender"
            name="gender"
            control={control}
            options={[
              { label: 'Select Gender', value: '' },
              { label: 'Male', value: 'Male' },
              { label: 'Female', value: 'Female' },
              { label: 'Others', value: 'Others' }
            ]}
            placeholder=""
            required={true}
            errors={errors}
            className="custom-input-pd form-custom-group"            
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <InputField
            label="Contact Number"
            name="phone"
            type="text"
            placeholder="Contact Number"
            controlclass="form-custom-group"
            required={true}
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <InputField
            label="Email"
            name="email"
            type="text"
            placeholder="Email"
            controlclass="form-custom-group"
            required={true}
            register={register}
            className="custom-input-pd"
            errors={errors}
          />
        </Col>
      </Row>

      <Row>
            <Col md={12}>
              <Form.Group controlId="profileImageInpt" className="mb-3 profile-imagegroup-maindiv">
                <Form.Label>Photo</Form.Label>

                <div className="custom-upload-wrapper">
                  {fileUploading && (
                    <div className="upload-overlay">
                      <Spinner animation="border" size="sm" />
                    </div>
                  )}

                  <Form.Control
                    type="file"
                    name="profileImageInpt"
                    onChange={handleFileChange}
                    disabled={fileUploading}
                    className={!!errors?.['profileImageInpt'] ? 'custom-file-input is-invalid' : 'custom-file-input'}
                  />

                  
                  <div className="upload-placeholder">
                    <i className="bx bx-upload"></i>
                    <span>Upload</span>
                  </div>
                  
                </div>
                {file && (
                    <div className="uploaded-file">
                      <img src={imageIcon} alt='icon' />
                      <div>
                        <div className="file-name">{file.name}</div>
                        <div className="file-size">
                          {(file.size / 1024).toFixed(0)} kb
                        </div>
                      </div>
                    </div>
                  )}
                <Form.Control.Feedback type="invalid">
                  {errors?.['profileImageInpt']?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>



      <div className="col-md-12 d-flex justify-content-between mt-auto pt-2 action-btn-buttomdiv">
        <Button variant="secondary custom-cnl-btncls" disabled={actiondisable || isSubmitting || loading} type="button" onClick={() => reset()}>
          Reset
        </Button>
        <Button type="submit" disabled={actiondisable || isSubmitting || loading} variant="primary custom-sbm-btncls">
          {loading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
              {' '}{mode === 'edit' ? 'Updating bunk...' : 'Adding bunk...'}
            </>
          ) : (
            mode === 'edit' ? 'Next' : 'Next'
          )}
        </Button>
      </div>
    </form>
  );
};

export default InchargeForm;
